import {defineStore} from "pinia";
import {Ref, computed, ref} from "vue";
import axios from "axios";
import {getGetParameterStringsFromKeyValueObject, getUrlVars} from "@k/global/globalUtils";

export type DetailAnsichtUrlAndText = {
    url:string,
    modelGroesse:string,
    produktGroesse:string,
}

export type ProduktInformationHighlight = {
    imageSource:string
    responsiveImage:string
    imageID:string
    title:string
    description:string
    name:string
}

export type ProduktInformation = {
    description:string,
    images:DetailAnsichtUrlAndText[],
    highlights:ProduktInformationHighlight[],
    hasTackleTwill:boolean,
    hatMusterService:boolean
}


export const useProductInfoStore = defineStore("productInfo", ()=>{
    const produktInformation = ref({
        description:"",
        images:[],
        highlights:[],
        hasTackleTwill:false,
        hatMusterService:false
    }) as Ref<ProduktInformation>;
    const loadedFor = ref("");

    const load = (webproductNormalized:string, websportNormalized:string, language:string, land:string)=>{
        loadedFor.value = "";
        axios.get("/konfigurator_php/produktinformation/loadProduktInformation.php"+getGetParameterStringsFromKeyValueObject(
            {
            webproduct:webproductNormalized, webSport:websportNormalized, language, land
            }
            )
        ).then(response=>{
            loadedFor.value = webproductNormalized;
            produktInformation.value = response.data
        })
    }
    return {
        get:computed(()=>produktInformation.value),
        load,
        isLoadedFor: (webproductNormalized :string)=>loadedFor.value === webproductNormalized
    }

})